import * as React from 'react';
import { ToxnotReactModal, ToxnotReactModalBody, ToxnotReactModalFooter } from '../ToxnotReactModal';
import { IStringLocalizer } from '../../../utilities/IStringLocalizer';
import { useLocalizer } from './hooks/useLocalizer';

interface AIDeleteModalProps {
    isOpen: boolean;
    onConfirm: () => void;
    onCancel: () => void;
    localizer?: IStringLocalizer;
}

export const AIDeleteModal: React.FC<AIDeleteModalProps> = ({
    isOpen,
    onConfirm,
    onCancel,
    localizer
}) => {
    const localize = useLocalizer(localizer);

    if (!isOpen) {
        return null;
    }

    return (
        <ToxnotReactModal
            modalId="ai-delete-modal"
            localizedTitle={localize('Delete All AI-Generated Answers?')}
            additionalClasses="ai-delete-modal-left-align"
        >
            <ToxnotReactModalBody>
                <div className="alert alert-warning ai-delete-modal-warning-box">
                    <p className="ai-delete-modal-message">
                        {localize('This action will permanently remove all AI-suggested answers from your survey.')}
                    </p>
                    <p className="ai-delete-modal-message">
                        {localize("You'll need to go through the survey manually or upload new documents for fresh AI suggested answers.")}
                    </p>
                    <p className="ai-delete-modal-warning">
                        <strong>{localize('This action cannot be undone.')}</strong>
                    </p>
                </div>
            </ToxnotReactModalBody>
            <ToxnotReactModalFooter enabledCloseButton={false} localizer={localizer!}>
                <button
                    type="button"
                    className="btn btn-toxnot-primary ai-delete-modal-cancel-button"
                    data-dismiss="modal"
                    onClick={onCancel}
                >
                    {localize('Cancel')}
                </button>
                <button
                    type="button"
                    className="btn btn-toxnot-danger ai-delete-modal-delete-button"
                    data-dismiss="modal"
                    onClick={onConfirm}
                >
                    {localize('Delete All Answers')}
                </button>
            </ToxnotReactModalFooter>
        </ToxnotReactModal>
    );
};

export default AIDeleteModal;
